import { useState } from 'react'
import { reloadForUpdate } from './pwaState'
import { usePwa } from './usePwa'

/** Small bar shown when a new version of the app is ready; reloading is always the user's call. */
export default function PwaUpdateToast() {
  const { updateReady } = usePwa()
  const [dismissed, setDismissed] = useState(false)
  if (!updateReady || dismissed) return null

  return (
    <div
      role="status"
      className="fixed inset-x-3 bottom-3 z-[90] mx-auto flex max-w-md items-center gap-3 border border-[#272C32] bg-[#18181A] px-4 py-3 shadow-[0_24px_48px_rgba(0,0,0,0.5)] pb-[calc(0.75rem+env(safe-area-inset-bottom,0px))]"
    >
      <i className="ri-download-cloud-2-line text-xl text-m1-violet" aria-hidden="true" />
      <p className="min-w-0 flex-1 text-[14px] leading-snug text-m1-ink">
        A new version of M1NT is available.
      </p>
      <button
        type="button"
        onClick={reloadForUpdate}
        className="min-h-[36px] shrink-0 border border-m1-violet px-3 text-[13px] text-m1-violet transition-colors hover:bg-m1-violet hover:text-m1-ground"
      >
        Reload
      </button>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        className="flex h-9 w-9 shrink-0 items-center justify-center text-m1-muted transition-colors hover:text-m1-ink"
      >
        <i className="ri-close-line text-lg" aria-hidden="true" />
      </button>
    </div>
  )
}
